import React from "react";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Button, makeStyles } from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import AlertTitle from "@material-ui/lab/AlertTitle";
import ComfirmedCreativeList from "./ConfirmedCreativeList";
import { useLocation } from "react-router-dom";

import { setCreativeApiError } from "../../../actions/app/creatives";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    "& > * + *": {
      marginTop: theme.spacing(2)
    }
  },
  alert: {
    alignItems: "center"
  },
  message: {
    width: "100%",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center"
  },
  link: {
    textDecoration: "none"
  }
}));

const Confirmation = ({
  handleResetParent,
  isMultiAdvertiser = false,
  traffickedCreatives
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const apiError = useSelector((state) => state.creatives.apiError);
  const creatives = useSelector((state) => Object.values(state.creatives.byId));
  const global = useSelector((state) => state.global);
  
  let location = useLocation();
  let returnText =
    location.pathname === "/preloader" ? "main screen" : "placement selection";

  const handleReset = () => {
    dispatch(setCreativeApiError(new Error(), false));
    handleReset();
  };

  const handleReturn = () => {
    dispatch(setCreativeApiError(new Error(), false));
  };

  if (global.smartLoader.loading) return null;

  const errorMessages = apiError.error.message.split("\n");

  return (
    <div>
      {apiError.isError ? (
        <div className={classes.root}>
          <Alert
            severity="error"
            className={classes.alert}
            classes={{ message: classes.message }}
          >
            <div>
              <AlertTitle>
                There were errors with the creatives attempting to be submitted.
                Please try again.
              </AlertTitle>
              {errorMessages.map((message, index) => {
                return (
                  <React.Fragment key={index}>
                    <span>{message}</span>
                    <br />
                  </React.Fragment>
                );
              })}
            </div>
            <Button onClick={handleReset} disableElevation>
              Return to Step 1
            </Button>
          </Alert>
        </div>
      ) : (
        <div className={classes.root}>
          <Alert
            severity="success"
            className={classes.alert}
            classes={{ message: classes.message }}
          >
            Selected creatives have been successfully submitted.
            <Link to="/" className={classes.link}>
              <Button onClick={handleReturn} disableElevation>
                Return to {returnText}
              </Button>
            </Link>
          </Alert>
        </div>
      )}
    </div>
  );
};

export default Confirmation;
